module.exports = __webpack_public_path__ + "img/7.6ea7feb3.png";